export default "__VITE_ASSET__VNFZFDHD__"